import React from 'react'
import Private from 'app/Private'
import { useIsAuthenticated } from 'hooks/use-is-authenticated'
import PrivateRoutes from './auth/PrivateRoutes'

const PrivateRoutesWrapper: React.FC = () => {
  const authenticated = useIsAuthenticated()

  return <PrivateRoutes isLoggedIn={authenticated} path='/' component={Private} />
}

export default PrivateRoutesWrapper
